<template>
  <div class="crowdfunding-box" v-if="itemList.length">
    <div class="title">
      <h1>{{ title }}</h1>
    </div>
    <div v-for="(item, idx) in itemList" :key="idx">
      <div class="box">
        <div class="flex flex-s list-item">
          <div class="img-container">
            <div class="flex cd">
              <i class="icon"></i>
              <!--<CountDown class="count-down" v-if="endTime" endShow="true" @timeEnd="timeEnd(index)" :endTime="item.endTime"-->
              <!--:text="['即将开始:', '活动剩余:', '活动剩余:'][item.status] "></CountDown>-->
              <!-- {{dateFormate(new Date(item.status === 0 ? item.startTime : item.endTime), 'yyyy-MM-dd hh:mm:ss')}}
              {{item.status === 0 ? '开始' : '结束'}} -->

              <CountDown
                v-if="item.endTime && item.status === 0"
                :format="'::'"
                endShow="true"
                @timeEnd="timeEnd(index)"
                :endTime="item.endTime"
                :text="['', '距离结束仅剩 ', '距离结束仅剩 '][item.status]"
              >
              </CountDown>
              {{ item.status === 0 ? '后开始' : dateFormate(new Date(item.endTime), 'yyyy-MM-dd hh:mm:ss') + ' 结束' }}
            </div>
            <img :src="item.mainImage" />
          </div>
          <div class="flex flex-s item-container">
            <div
              class="item"
              v-for="(rank, index) in item.rankList"
              :key="index"
              :class="{ 'has-border': index < item.rankList.length - 1 }"
            >
              <p class="ladder-tname">{{ item.name }}</p>
              <p class="ladder-name">{{ rank.ladderName }}</p>
              <div ref="info" :style="{ height: height }">
                <div class="main-info flex" v-for="(desc, index) in rank.description" :key="index">
                  <i
                    class="icon-eq"
                    :style="{
                      'background-image': 'url(' + equityPic[index] + ')',
                      'min-height': iconHeight[index] + 'px'
                    }"
                  ></i>
                  <p>{{ desc }}</p>
                </div>
              </div>
              <div class="extra">
                <p class="flex mb-28"><i class="icon-fire"></i>预订人数{{ rank.orderNumber }}人</p>
                <button @click="toDetail(item, rank.ladderIndex)">
                  立即预订
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="chance" v-if="isLogin && item.residueTime > 0 && item.status > 0 && item.ifCouponInvalid">
          <!-- <p v-if="item.ladderDto && item.useUpgradeTime > 0">您已下订，还可获得<span class="c-red">{{item.residueTime}}</span>次权益升级资格，</p>
          <p v-else-if="item.ladderDto && item.useUpgradeTime === 0">您已下订，可获得<span class="c-red">{{item.residueTime}}</span>次权益升级资格，</p> -->

          <p v-if="item.ladderDto && item.useUpgradeTime > 0">
            您已获得<span class="c-red">{{
              item.residueTime === 2 ? '500' : item.residueTime === 1 ? '666' : '777'
            }}</span
            >元购车红包！ 还有<span class="c-red">{{ item.residueTime }}</span
            >次红包升档机会
          </p>
          <p v-else-if="item.ladderDto && item.useUpgradeTime === 0">
            您已获得<span class="c-red">{{
              item.residueTime === 2 ? '500' : item.residueTime === 1 ? '666' : '777'
            }}</span
            >元购车红包！ 还有<span class="c-red">{{ item.residueTime }}</span
            >次红包升档机会
          </p>

          <!-- 拥有的次数===0,显示可 -->
          <!-- <p v-else-if="item.upgradeTime === 0">
            还有<span class="c-red">{{ item.residueTime }}</span
            >次红包升档机会
          </p> -->
          <p v-else-if="item.upgradeTime === 0">
            下订即可获得500元购车红包！
          </p>
          <!-- <p v-else class="gearText">
            您已获得<span class="c-red">{{ item.upgradeTime }}</span
            >次权益升级资格，下单即可使用, 还可获得<span class="c-red">{{
              item.residueTime
            }}</span
            >次权益升级资格，
          </p> -->
          <p v-else class="gearText">
            下订即可获得500元购车红包！
          </p>
          <el-popover
            v-if="isLogin && item.getTimes !== item.expandNum && item.ladderDto"
            popper-class="link-crow"
            ref="popover1"
            placement="top"
            width="300"
            height="347"
            trigger="hover"
            class="link"
          >
            <!-- <el-popover
            v-if="item.getTimes !== item.expandNum"
            popper-class="link-crow"
            ref="popover1"
            placement="top"
            width="300"
            height="347"
            trigger="hover"
            class="link"
            @show="showCode(idx)"
            @hide="closeCode(idx)"
          > -->
            <div class="qrcodeBox-ym">
              <img :style="{ width: '220px', height: '220px' }" src="@/assets/images/mini/miniqr.jpg" alt="" />
            </div>
            <p class="gearText s">微信扫码参与小程序活动，获取权益升级资格</p>
            <!-- <p v-if="item.upgrateTime === 0">您可获得<span class="c-red">{{item.residueTime}}</span>次权益升级资格</p>
            <p v-else class="gearText" >您还可获得<span class="c-red">{{item.residueTime}}</span>次权益升级资格，扫码获取</p>
            <a v-if="item.expandNum === item.residueTime && item.getTimes !== item.expandNum" slot="reference" >去获取>></a> -->
            <a slot="reference">去获取>></a>
          </el-popover>
        </div>
        <div class="chance" v-if="isLogin && item.residueTime === 0 && item.ladderDto && item.ifCouponInvalid">
          <!-- <p>
            您已获得最高购车权益，<span
              @click="toCouponList"
              class="c-red cursor"
              >查看优惠券></span
            >
          </p> -->
          <p>
            您已获得777元购车红包！
          </p>
        </div>
        <div class="chance" v-if="isLogin && item.residueTime === 0 && !item.ladderDto && item.ifCouponInvalid">
          <!-- <p>
            您已获得全部<span class="c-red">{{ item.expandNum }}</span
            >次权益升级资格，赶紧下单使用吧>
          </p> -->
          <p>
            下订即可获得500元购车红包！
          </p>
        </div>
        <div class="chance" v-if="!isLogin">
          <p>下订即可获得500元购车红包！</p>
          <el-popover
            popper-class="link-crow"
            ref="popover2"
            placement="top"
            width="300"
            height="347"
            trigger="hover"
            class="link"
          >
            <!-- <el-popover
            popper-class="link-crow"
            ref="popover2"
            placement="top"
            width="300"
            height="347"
            trigger="hover"
            class="link"
            @show="showCodex(idx)"
            @hide="closeCodex(idx)"
          > -->
            <div class="qrcodeBox-ym">
              <img :style="{ width: '220px', height: '220px' }" src="@/assets/images/mini/miniqr.jpg" alt="" />
            </div>
            <!-- <div :id="`qrcode-crow-mallx${idx}`" class="qrcodeBox-ym"></div> -->
            <p class="gearText s">微信扫码参与小程序活动，获取权益升级资格</p>
            <a slot="reference" v-if="isLogin">去获取>></a>
          </el-popover>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
// import { Progress } from 'element-ui'
// import Car from '@/page/seller/components/car.vue'
import CountDown from '@/components/common/CountDown'
import { getStorage, dateFormate } from '@/lib/utils'
// import QRCode from 'qrcodejs2'
// import aConfig from '@/lib/activityConfig'

import first from '@/assets/images/activity/crowdfunding/first.png'
import second from '@/assets/images/activity/crowdfunding/second.png'
import third from '@/assets/images/activity/crowdfunding/third.png'
import fourth from '@/assets/images/activity/crowdfunding/fourth.png'
import fifth from '@/assets/images/activity/crowdfunding/fifth.png'
import sixth from '@/assets/images/activity/crowdfunding/sixth.png'

export default {
  name: 'crowdfunding',
  components: {
    // ElProgress: Progress,
    CountDown
    // Car,
    // QRCode
  },
  data() {
    return {
      dateFormate,
      itemList: [],
      rankList: [],
      title: '众筹',
      ungrateTime: null,
      residueTime: null,
      ladderDto: null,
      height: 'auto',
      titleHeight: 0,
      equityPic: [second, fourth, first, fifth, third, sixth],
      iconHeight: [20, 16, 20, 24, 16, 20],
      isLogin: false
    }
  },
  props: {
    crowdfunding: {
      type: Object,
      default: () => {}
    }
  },
  updated() {
    if (this.height === 'auto') {
      let height = 0
      this.$refs.info &&
        this.$refs.info.forEach((item) => {
          if (item.offsetHeight > height) height = item.offsetHeight
        })
      this.height = height + 24 + 'px'
    }
  },
  created() {
    const isLogin = !!getStorage('accessToken')
    this.title = this.crowdfunding.params.title
    this.isLogin = isLogin
    this.itemList = this.crowdfunding.params.crowdfunding.itemList
    // this.crowdfunding.params.crowdfunding.itemList
    //   .filter((item) => item.activityTag)
    //   .forEach((item, index) => {
    //     const { startTime, endTime } = item.activityTag
    //     const now = new Date().getTime()
    //     item.status = 1
    //     item.endTime = endTime
    //     item.startTime = startTime
    //     if (now > endTime) {
    //       item.status = 2
    //     } else if (now < startTime) {
    //       item.status = 0
    //       item.endTime = startTime
    //     }
    //     this.$api
    //       .getActivityInfo({
    //         itemId: item.id,
    //         activityId: item.activityTag.activityId,
    //         activityType: 7
    //       })
    //       .then((res) => {
    //         if (res.status !== 200) {
    //           return
    //         }
    //         const rankList = res.data.activityQueryInfos[0].activityInfoDtos[0].ladderDtoList
    //         // const carName = item.name
    //         rankList.map((item) => {
    //           item.description = item.description.replace(/#/g, '#').split('#')
    //           return item
    //         })
    //         item.rankList = rankList
    //         this.$set(this.itemList, index, item)
    //         if (isLogin) {
    //           this.$api
    //             .getUpgrateTime({
    //               activityCode: res.data.activityQueryInfos[0].activityCode
    //             })
    //             .then(
    //               (data) => {
    //                 let { upgradeTime, ladderDto, useUpgradeTime, expandNum, ifCouponInvalid } = data
    //                 item.ifCouponInvalid = ifCouponInvalid
    //                 let ladderIndex = ladderDto ? ladderDto.ladderIndex : 0
    //                 const getTimes = ladderIndex + upgradeTime
    //                 item.upgradeTime = upgradeTime
    //                 item.useUpgradeTime = useUpgradeTime
    //                 item.expandNum = expandNum
    //                 item.residueTime = expandNum - getTimes > 0 ? expandNum - getTimes : 0
    //                 item.ladderDto = ladderDto
    //                 item.getTimes = getTimes
    //                 this.$set(this.itemList, index, item)
    //               },
    //               (err) => console.log(err)
    //             )
    //         }
    //       })
    //   })
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.box-360 {
  width: 1360px !important;
  height: 300px;
  margin: 0 auto;
  .prestrainImg .img {
    background-size: 300px 300px !important;
  }
}

.flex-a {
  justify-content: flex-start;
  align-items: self-start;
}

.flex {
  display: flex;
  align-items: center;
}

.flex-s {
  align-items: flex-start;
  justify-content: space-between;
}

.flex-g {
  flex-grow: 1;
}

.c-red {
  color: #da1f46;
  // margin-left: 5px;
}
.cursor {
  cursor: pointer;
}
.h-100 {
  height: 100%;
}
.mb-28 {
  margin-bottom: 28px;
}

.crowdfunding-box {
  box-sizing: border-box;
  width: 1360px;
  padding-right: 10px;
  margin: 0 auto;
  .list-item {
    position: relative;
    min-height: 295px;
    height: auto;
    .img-container {
      font-size: 18px;
      color: #333;
      padding: 17px 0 0 30px;
    }
    .item-container {
      min-height: 295px;
      height: auto;
      box-sizing: border-box;
      flex-grow: 1;
    }
    .cd {
      margin-bottom: 58px;
    }
    img {
      box-sizing: border-box;
      width: 420px;
      height: 190px;
    }
    .icon {
      background-image: url('../../../assets/images/activity/icon-time.png');
      width: 19px;
      height: 19px;
      margin-right: 5px;
    }
  }
  .title {
    width: 100%;
    // height: 70px;
    font-size: 22px;
    font-family: 'NotoSansHans-Bold';
    font-weight: bold;
    // padding-top: 20px;
    // margin-bottom: 10px;
    margin-bottom: 25px;
    padding-top: 40px;
    /* background-color: lightblue; */
    display: flex;
    justify-content: space-between;
    align-items: center;
    h1 {
      height: 42px;
      font-size: 30px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #000000;
      line-height: 42px;
      padding-left: 24px;
      position: relative;
    }
    h1:after {
      content: '';
      width: 4px;
      height: 24px;
      background: #c6001f;
      position: absolute;
      left: 0;
      top: 10px;
    }
  }

  .item {
    box-sizing: border-box;
    width: 296px;
    font-size: 16px;
    color: #393c51;
    background: #fff;
    position: relative;
    padding: 30px 20px 36px 20px;
    min-height: 295px;
    height: auto;
    &:last-child {
      padding-right: 30px !important;
    }
    .main-info {
      align-items: flex-start;
      margin-bottom: 3px;
      // height:40px;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 24px;
      color: #666;
    }
    &.has-border {
      &:after {
        position: absolute;
        width: 1px;
        height: 195px; //100px;
        background: rgba(216, 216, 216, 1);
        right: 0;
        content: '';
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .ladder-name {
      font-size: 24px;
      font-weight: 500;
      color: rgba(57, 60, 81, 1);
      line-height: 33px;
      margin-bottom: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .ladder-tname {
      font-size: 24px;
      font-weight: 500;
      color: rgba(57, 60, 81, 1);
      line-height: 33px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .extra {
      // margin-top: 26px;
    }

    button {
      width: 234px;
      height: 44px;
      font-size: 20px;
      color: #393c51;
      background: rgba(255, 255, 255, 1);
      outline: none;
      border: 1px solid rgba(224, 224, 225, 1);
      cursor: pointer;
      &:hover {
        background: rgba(223, 61, 54, 1);
        color: #fff;
        border: 1px solid rgba(223, 61, 54, 1);
      }
    }
    .icon-fire {
      margin-right: 12px;
      display: inline-block;
      width: 16px;
      height: 20px;
      background-image: url('../../../assets/images/activity/icon-fire.png');
    }
    .icon-eq {
      margin-right: 10px;
      margin-left: 0;
      display: inline-block;
      min-width: 18px;
      height: 18px;
      -webkit-background-size: contain;
      background-size: contain;
      background-repeat: no-repeat;
      transform: translateY(5px);
    }
  }
  .box {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
    background: #fff;
  }
  .chance {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;
    font-size: 18px;
    color: rgba(57, 60, 81, 1);
    line-height: 25px;
    text-indent: 507px;
    margin-top: -14px;
    padding-bottom: 30px;
    a {
      color: #c6001f;
      text-decoration: underline;
      cursor: pointer;
    }

    & ::v-deep {
      .link {
        width: 100px;
        text-indent: 0;
        p {
          text-align: center;
        }
      }
      .gearText {
        text-align: center;
      }
      .el-popover__reference {
        width: 100px;
        color: #c6001f;
        text-decoration: underline;
        cursor: pointer;
      }
      .el-popover {
        left: 800px !important;
        transform: translateX(-50%);
      }
    }
  }
  .progress {
    margin: 15px 0;
  }
  .c-red {
    color: #c6001f;
  }
}
</style>

<style lang="scss">
.link-crow {
  padding: 0;
  height: 343px;
  p.gearText {
    text-align: center;
    font-size: 18px;
    color: #666;
  }
  .s {
    margin: 0 15px;
    font-size: 16px !important;
  }
}
.qrcodeBox-ym {
  margin: 42px 40px 26px;
}
</style>
